import type { OrderParams } from '~domains/orders/entities/product';

import { formatMoney } from '~shared/lib/format-money';

export function validateLoanAmount(totalPrice: number, params: OrderParams) {
  if (totalPrice > params.maxOrderTotalAmount) {
    return (
      <>
        Lessen by {formatMoney(totalPrice - params.maxOrderTotalAmount)}{' '}
        to&nbsp;be within the&nbsp;maximum amount of&nbsp;
        {formatMoney(params.maxOrderTotalAmount)}
      </>
    );
  }

  if (totalPrice < params.minOrderTotalAmount) {
    return (
      <>
        Add {formatMoney(params.minOrderTotalAmount - totalPrice)} to&nbsp;reach
        the&nbsp;minimum amount of&nbsp;
        {formatMoney(params.minOrderTotalAmount)}
      </>
    );
  }

  return undefined;
}
